import React, { Fragment, useState } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { profitLossReport } from "../../../services/accounts";
import { exportPDF, exportExcel } from "./exportUtils";

export default function ProfitLoss() {
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate]     = useState(moment().format("YYYY-MM-DD"));
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(false);

  function handleSearch() {
    setLoading(true);
    const temp = new FormData();
    temp.append("from_date", fromDate);
    temp.append("to_date", toDate);
    if (localStorage.getItem("Role") === "1") {
      temp.append("academy_id", localStorage.getItem("AAcademy") || "");
    }
    profitLossReport(temp).then((res) => {
      setLoading(false);
      if (res?.status) setData(res.data);
    });
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Profit & Loss</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Accounts</a></li>
            <li className="breadcrumb-item active" aria-current="page">Profit & Loss</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      min={fromDate || undefined}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      <a onClick={handleSearch} className="btn btn-success">
                        {loading ? "Loading..." : "Show"}
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          {data && (
            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">
                    Profit & Loss — {moment(data.from_date).format("DD MMM YYYY")} to {moment(data.to_date).format("DD MMM YYYY")}
                  </h5>
                  <div>
                    <a onClick={() => {
                      const cols = ["Type", "Ledger", "Amount"];
                      const rows = [
                        ...(data.income  || []).map((r) => ["Income",  r.ledger_name, parseFloat(r.amount).toFixed(2)]),
                        ["", "Total Income", data.total_income?.toFixed(2)],
                        ...(data.expense || []).map((r) => ["Expense", r.ledger_name, parseFloat(r.amount).toFixed(2)]),
                        ["", "Total Expense", data.total_expense?.toFixed(2)],
                        ["", data.is_profit ? "Net Profit" : "Net Loss", Math.abs(data.net_profit).toFixed(2)],
                      ];
                      exportPDF(`Profit & Loss - ${moment(data.from_date).format("DD MMM YYYY")} to ${moment(data.to_date).format("DD MMM YYYY")}`, cols, rows);
                    }} className="btn btn-danger btn-sm me-2">
                      <i className="fa fa-file-pdf-o me-1" /> PDF
                    </a>
                    <a onClick={() => {
                      const cols = ["Type", "Ledger", "Amount"];
                      const rows = [
                        ...(data.income  || []).map((r) => ["Income",  r.ledger_name, parseFloat(r.amount).toFixed(2)]),
                        ["", "Total Income", data.total_income?.toFixed(2)],
                        ...(data.expense || []).map((r) => ["Expense", r.ledger_name, parseFloat(r.amount).toFixed(2)]),
                        ["", "Total Expense", data.total_expense?.toFixed(2)],
                        ["", data.is_profit ? "Net Profit" : "Net Loss", Math.abs(data.net_profit).toFixed(2)],
                      ];
                      exportExcel(`Profit & Loss - ${moment(data.from_date).format("DD MMM YYYY")} to ${moment(data.to_date).format("DD MMM YYYY")}`, cols, rows);
                    }} className="btn btn-success btn-sm">
                      <i className="fa fa-file-excel-o me-1" /> Excel
                    </a>
                  </div>
                </div>
                <Row className="row-sm mx-0">
                  <Col lg={6} md={12} className="mb-3">
                    <table className="table table-bordered table-sm">
                      <thead style={{ backgroundColor: "#2d4ac6", color: "#fff" }}>
                        <tr><th colSpan={2} className="text-center">Income</th></tr>
                        <tr><th>Ledger</th><th className="text-end">Amount</th></tr>
                      </thead>
                      <tbody>
                        {data.income?.map((row, i) => (
                          <tr key={i}>
                            <td>{row.ledger_name}</td>
                            <td className="text-end">{parseFloat(row.amount).toFixed(2)}</td>
                          </tr>
                        ))}
                        {data.income?.length === 0 && <tr><td colSpan={2} className="text-muted text-center">No income</td></tr>}
                      </tbody>
                      <tfoot>
                        <tr className="fw-bold">
                          <td>Total Income</td>
                          <td className="text-end">{data.total_income?.toFixed(2)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </Col>
                  <Col lg={6} md={12} className="mb-3">
                    <table className="table table-bordered table-sm">
                      <thead style={{ backgroundColor: "#2d4ac6", color: "#fff" }}>
                        <tr><th colSpan={2} className="text-center">Expense</th></tr>
                        <tr><th>Ledger</th><th className="text-end">Amount</th></tr>
                      </thead>
                      <tbody>
                        {data.expense?.map((row, i) => (
                          <tr key={i}>
                            <td>{row.ledger_name}</td>
                            <td className="text-end">{parseFloat(row.amount).toFixed(2)}</td>
                          </tr>
                        ))}
                        {data.expense?.length === 0 && <tr><td colSpan={2} className="text-muted text-center">No expense</td></tr>}
                      </tbody>
                      <tfoot>
                        <tr className="fw-bold">
                          <td>Total Expense</td>
                          <td className="text-end">{data.total_expense?.toFixed(2)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </Col>
                </Row>
                <div className="text-center fw-bold fs-5 mt-3">
                  {data.is_profit ? "Net Profit" : "Net Loss"}: ₹{Math.abs(data.net_profit).toFixed(2)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
